import { useEffect } from 'react';

import {
  CHANNEL_STATUS,
  TChannelStatus,
  useInvalidateChannelById,
  useInvalidateChannelsList,
} from '@/entities/channel';

import {
  refetchToGetQrCode,
  refetchToUpdateQrCode,
  useChannelById,
} from '../useChannelById';

const getIsFinalStatus = (status?: TChannelStatus) => {
  return (
    status === CHANNEL_STATUS.AUTHORIZED ||
    status === CHANNEL_STATUS.READY ||
    status === CHANNEL_STATUS.CONTACTS_SYNCED ||
    status === CHANNEL_STATUS.CHATS_SYNCED ||
    status === CHANNEL_STATUS.PASSWORD_REQUIRED
  );
};

export const useQrCodeByChannel = (
  channelId?: string,
  isPollingEnabled?: boolean,
  enabledQuery: boolean = true,
  onScanned?: () => void
) => {
  const invalidateChannelsList = useInvalidateChannelsList();
  const invalidateChannelById = useInvalidateChannelById();
  const {
    channelByIdData,
    error: errorChannel,
    isError: isErrorChannel,
  } = useChannelById(channelId, {
    refetchInterval: (query) => {
      const status = query.state?.data?.status;

      if (!isPollingEnabled || getIsFinalStatus(status)) {
        return false;
      }

      return !query.state.data?.qr_url
        ? refetchToGetQrCode(query, channelId)
        : refetchToUpdateQrCode(query, channelId);
    },
    enabled: enabledQuery,
  });

  // Вызов колбэка успеха при достижении финального статуса
  useEffect(() => {
    const handleFinalStatus = async () => {
      if (enabledQuery && getIsFinalStatus(channelByIdData?.status)) {
        await Promise.all([
          invalidateChannelsList(),
          invalidateChannelById(channelByIdData.id),
        ]);
        onScanned?.();
      }
    };

    handleFinalStatus();
  }, [
    channelByIdData?.status,
    channelByIdData?.id,
    enabledQuery,
    invalidateChannelsList,
    onScanned,
    invalidateChannelById,
  ]);

  return {
    dataChannelById: channelByIdData,
    error: errorChannel,
    isError: isErrorChannel,
    isFinalStatus: getIsFinalStatus(channelByIdData?.status),
  };
};
